import { useRightPanel } from '@/components/layout/workspace/rightPanelContext';
import { KanbanBoard, Select, SelectTrigger, SelectContent, SelectItem, SelectValue } from '@/components/ui';
import { useState } from 'react';
import { COLUMNS, HOME, SAMPLE_NOW } from './model';
import { useOperations } from './operationsContext';
export function BoardDemo() {
  const { cards, move } = useOperations();
  const [view, setView] = useState('ready');
  const panel = useRightPanel();
  return (
    <div data-demo="board" className="flex flex-col gap-4">
      <p className="text-sm text-fg-muted">
        Перенеси карточку между колонками. У ручки доступен перенос с клавиатуры; выполненное действие можно
        отменить.
      </p>
      <div className="w-56 max-w-full">
        <Select value={view} onValueChange={setView}>
          <SelectTrigger aria-label="Состояние доски">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="ready">Примерные записи</SelectItem>
            <SelectItem value="empty">Пустые колонки</SelectItem>
          </SelectContent>
        </Select>
      </div>
      <KanbanBoard
        columns={COLUMNS}
        items={view === 'empty' ? [] : cards}
        onMove={move}
        now={SAMPLE_NOW}
        onOpen={(item, trigger) =>
          panel.open(
            {
              id: item.id,
              title: item.title,
              path: HOME + '/item/' + item.id,
              eyebrow: 'Запись № ' + item.id,
            },
            trigger,
          )
        }
      />
    </div>
  );
}
